<template>
    <div class="space-y-4">
        <div class="flex flex-wrap gap-1">
            <button style="margin-bottom: -16px;" v-for="grupo in gruposOrdenados" :key="grupo.grupo"
                @click="abaAtiva = grupo.grupo"
                class="tab-btn py-1 text-sm font-medium rounded-t-lg border transition-colors whitespace-nowrap relative"
                :class="{
                    'px-2 ': sidebarOpen,
                    'px-3': !sidebarOpen,
                    'ativa bg-blue-50 text-blue-900 border-blue-200 border-b-0 font-semibold':
                        abaAtiva === grupo.grupo,
                    'bg-yellow-lete text-cinza-600 border-cinza-200 hover:text-cinza-700 ':
                        abaAtiva !== grupo.grupo
                }">
                {{ grupo.label }}
            </button>
        </div>
        <div class="tab-card bg-blue-50 border border-blue-200 rounded-lg p-4 relative">
            <div v-if="!items || items.length === 0" class="py-2">
                <p class="text-sm text-gray-500 italic">
                    Nenhum acesso rápido disponível neste grupo.
                </p>
            </div>
            <div v-else class="grid grid-cols-2 gap-2">
                <div v-for="item in items" :key="item.id" class="flex items-center gap-2 p-2 rounded-md
                 hover:bg-blue-100 transition-colors cursor-pointer group" @click="handleClick(item)">
                    <div class="w-6 h-6 flex items-center justify-center flex-shrink-0">
                        <component :is="iconMap[item.icone]" class="w-4 h-4 text-blue-600" />
                    </div>
                    <span class="text-sm font-medium text-gray-800
                   group-hover:text-blue-800 truncate">
                        {{ item.descricao }}
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>


<script setup>
import { ref, computed, onMounted, onUnmounted } from 'vue'
import { usePage, router } from '@inertiajs/vue3'
import iconMap from '@/Utils/icons_utils'

const { acessos_rapidos } = usePage().props
const abaAtiva = ref('cidadao')
const sidebarOpen = ref(false)

const gruposOrdenados = computed(() => {
    if (!acessos_rapidos) return []
    const semGrupo = acessos_rapidos.find(g => g.grupo === 'sem-grupo')
    const outros = acessos_rapidos.filter(g => g.grupo !== 'sem-grupo')
    if (semGrupo) semGrupo.label = 'Geral'
    return semGrupo ? [semGrupo, ...outros] : outros
})

const grupoAtivo = computed(
    () => gruposOrdenados.value.find(g => g.grupo === abaAtiva.value) || { acessos: [] }
)

const items = computed(() => grupoAtivo.value.acessos || [])

const getHref = (item) => {
    if (item.status_link === 'interno') {
        try {
            return route(item.rota)
        } catch {
            return '#'
        }
    }
    return item.link || '#'
}

const handleClick = (item) => {
    // Se não tem route (status_link !== 'interno'), abre link externo
    if (!item.route) {
        if (item.link) {
            window.open(item.link, '_blank', 'noopener,noreferrer')
        }
        return
    }

    // É interno: usa router do Inertia
    router.visit(item.route)
}

const handleResize = () => {
    sidebarOpen.value = window.innerWidth < 1024
}

onMounted(() => {
    handleResize()
    window.addEventListener('resize', handleResize)
})

onUnmounted(() => {
    window.removeEventListener('resize', handleResize)
})
</script>

<style scoped>
.tab-card {
    border-top-left-radius: 0;
    border-top-right-radius: 14px;
}

.tab-btn.ativa::after {
    content: '';
    position: absolute;
    left: -1px;
    bottom: -1px;
    width: calc(100% + 2px);
    height: 2px;
    background-color: #eff6ff;
    z-index: 10;
}
</style>
